export default "__VITE_ASSET__DvC9WUUF__"